<template>
  <div>
    <v-layout class="mt-5" v-if="isLoading" align-center justify-center column fill-height="fill-height">
      <v-progress-circular size="70" width="7" color="purple" indeterminate="indeterminate">
      </v-progress-circular>
      <div>Loading...</div>
    </v-layout>
    <div v-if="!isLoading">
      <v-card class="px-2" tile>
        <v-row align="center">
          <v-col class="shrink">
            <v-btn text icon class="ml-0" @click="$router.go(-1)">
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
          </v-col>
          <v-col>
            <span>{{ location.CSPID }} - {{ location.businessName }}</span>
          </v-col>

          <v-col class="shrink">
            <v-btn fab icon @click="editStore">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
      <v-divider></v-divider>

      <v-card tile>
        <v-card-text>
          <div>
            <div>
              <span class="font-weight-regular">Account Number: </span>
              <span>{{ location.CSPID }}</span>
            </div>
            <div>
              <span class="font-weight-regular">Address: </span>
              <span>{{ location.address }}</span>
            </div>
            <div>
              <span class="font-weight-regular">Phone Number: </span>
              <span>{{ location.businessPhone }} </span>
            </div>
            <v-row class="mt-2">
              <v-col class="shrink">
                <v-chip v-if="location.isLocked" color="info" text-color="white" small>Locked</v-chip>
              </v-col>
              <v-col class="shrink">
                <v-chip v-if="location.isCanceled" color="error" text-color="white" small>Canceled</v-chip>
              </v-col>
            </v-row>
          </div>
        </v-card-text>
      </v-card>

      <v-container fluid grid-list-lg class="pt-0 px-0">
        <v-tabs v-model="active">
          <v-tab v-if="service.pos" class="text-transform-none">{{ $t("labels.sale") }}</v-tab>
          <v-tab-item v-if="service.pos">
            <v-card-text v-if="sales">
              <v-layout column>
                <v-flex v-for="(sale, index) in sales" :key="index">
                  <v-chip label>{{ sale[0].GroupHeading }}</v-chip>
                  <v-list>
                    <div v-for="(detail, i) in sale" :key="i">
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title v-text="detail.Description"></v-list-item-title>
                        </v-list-item-content>

                        <v-list-item-action>
                          {{ detail.Amount | currency }}
                        </v-list-item-action>
                      </v-list-item>
                      <v-divider v-if="i + 1 < sale.length" :key="i"> </v-divider>
                    </div>
                  </v-list>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-text v-else>
              <div class="text-h4 text-center">Batch not found!</div>
            </v-card-text>




            <!-- <v-expansion-panels class="mt-4" focusable inset>
              <v-expansion-panel v-for="(sale, index) in sales" :key="index">
                <v-expansion-panel-header>{{ sale[0].GroupHeading }}</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-list>
                    <div v-for="(detail, i) in sale" :key="i">
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title v-text="detail.Description"></v-list-item-title>
                        </v-list-item-content>

                        <v-list-item-action>
                          {{ detail.Amount | currency }}
                        </v-list-item-action>
                      </v-list-item>
                      <v-divider v-if="i + 1 < sale.length" :key="i"> </v-divider>
                    </div>
                  </v-list>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels> -->

          </v-tab-item>
          <v-tab class="text-transform-none">{{ $t("labels.dashboard") }}</v-tab>
          <v-tab-item>
            <v-container fluid grid-list-md>
              <v-row>
                <v-col class="pt-0" xs="12" sm="4">
                  <v-row>
                    <v-col cols="12" class="pt-1" v-if="service.pos">
                      <DueDate :service="service.pos"> </DueDate>
                    </v-col>
                    <v-col cols="12">
                      <v-card outlined>
                        <v-toolbar class="elevation-0" height="45" color="gray">
                          <v-toolbar-title>
                            <h1 class="subtitle-1">{{ $t("labels.invoiceEmail") }}</h1>
                          </v-toolbar-title>
                          <v-spacer> </v-spacer>
                          <v-btn small color="pink" dark icon @click="invoiceEmail">
                            <v-icon small>mdi-lead-pencil</v-icon>
                          </v-btn>
                        </v-toolbar>
                        <v-card-text>
                          <v-layout column>
                            <v-layout row wrap>
                              <v-flex class="font-weight-regular">
                                <span>{{ location.invoiceEmail }}</span>
                              </v-flex>
                            </v-layout>
                          </v-layout>
                        </v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" v-if="service.pos">
                      <Plan> </Plan>
                    </v-col>
                    <v-col cols="12">
                      <credit-card :stripeID="location.stripeID"> </credit-card>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col xs="12" sm="8">
                  <ListByStore> </ListByStore>
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>
          <v-tab class="text-transform-none">Inventory</v-tab>
          <v-tab-item>
            <v-container fluid grid-list-md>
              <Inventory> </Inventory>
            </v-container>
          </v-tab-item>
          <v-tab class="text-transform-none" v-if="service.pos && service.pos.cSoftware.id === 54">{{ $t("labels.batch")
          }}</v-tab>
          <v-tab-item v-if="service.pos && service.pos.cSoftware.id === 54">
            <v-container fluid grid-list-md>
              <BatchStoreList> </BatchStoreList>
            </v-container>
          </v-tab-item>


          <v-tab class="text-transform-none" v-if="service.reconcile">{{
              $t("labels.reconcile")
          }}</v-tab>
          <v-tab-item lazy v-if="service.reconcile">
            <Reconcile> </Reconcile>
          </v-tab-item>
          <v-tab class="text-transform-none" v-if="service.commercial">{{
              $t("labels.commercial")
          }}</v-tab>
          <v-tab-item lazy v-if="service.commercial">
            <Commercial> </Commercial>
          </v-tab-item>
        </v-tabs>
      </v-container>
      <Edit :editDialog="editDialog" @close="close" @updated="updated"> </Edit>
    </div>
  </div>
</template>
<script>
import creditCardService from "../../Invoice/service.js";
import creditCard from "../components/CreditCard";
import Commercial from "../components/Commercial";
const Edit = () => import("../components/Edit");
const ListByStore = () => import("../../Invoice/components/ListByStore");
import BatchStoreList from "../../Batch/components/ListByStore";
import Plan from "../components/components/Plan";
import DueDate from "../components/components/DueDate";
import Reconcile from "../components/Reconcile";
import Inventory from "@/pages/Location/components/Inventory.vue";
import locationService from "@/pages/Location/service.js";
import _ from "lodash";

import { mapActions, mapGetters } from "vuex";

export default {
  name: "location-view-profile",
  data() {
    return {
      storeId: null,
      sales: null,
      editDialog: false,
      active: null,
      cancelDialog: false,
      Reports: {
        Sales: null
      },
      subscription: null,
      isLoading: true
    };
  },
  components: {
    Plan,
    Inventory,
    DueDate,
    Commercial,
    Edit,
    creditCard,
    BatchStoreList,
    Reconcile,
    ListByStore
  },
  async created() {
    // if (!this.location) return this.$router.push({ name: "location-dashboard" });
    // this.isLoading = false;
    try {
      await this.getById();
      await this.getCard();
      await this.getSale();
      this.isLoading = false;
    } catch (error) {
      console.log("error", error);
      this.isLoading = false
    }
  },
  computed: {
    ...mapGetters("location", ["location", "cards", "service"])
  },
  methods: {
    ...mapActions("location", ["setLocation", "setCard"]),
    getSale() {
      return locationService
        .getLocationSale(this.storeId)
        .then(response => {
          console.log("rkljasdf", response);
          const rowSale = response.data;
          if (rowSale.length) {
            this.sales = _.mapValues(
            _.groupBy(rowSale, row => row.HeadingID),
            list => {
              return list;
            }
          );
          } 
          
          console.log("sale", this.sales);
        })
        .catch(error => {
          return error
          console.log("error on sale", error);
        });
    },
    getById() {
      this.storeId = this.$route.params.id || 0;
      if (this.storeId === 0) {
        this.$router.push({ name: "location-dashboard" });
      }
      this.setLocation(this.storeId);
      return true
    },
    updateStore(data) {
      return locationService.updateStore(this.storeId, data).then(result => {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000
          })
          .fire({
            type: "success",
            title: "Update Successfully"
          });
        this.setLocation(this.storeId);
      });
    },
    async invoiceEmail() {
      const { value: email } = await this.$swal.fire({
        title: "Invoice Email",
        input: "email",
        showCancelButton: true,
        inputPlaceholder: "Enter New Email Address"
      });

      if (email) {
        this.updateStore({
          invoiceEmail: email
        });
        // this.$swal.fire('Entered email: ' + email)
      }
    },
    editStore() {
      this.editDialog = true;
    },
    close() {
      this.editDialog = false;
    },
    updated() {
      this.close();
    },
    getCard() {
      creditCardService.getStripeCard(this.storeId).then(result => {
        console.log("result", result);
        if (result.data && result.data.defaultCard) {
          let defaultCard = result.data.default_card;
          result.data.sources.data.map(row => {
            if (defaultCard === row.id) {
              this.setCard({
                id: row.id,
                label: row.last4 + " - " + row.type + " - Default"
              });
            } else {
              this.setCard({
                id: row.id,
                label: row.last4 + "-" + row.type
              });
            }
          });
        }
      });
    },
    loadSubscription() {
      return locationService.Billing.getSubscription(this.location.id)
        .then(response => {
          console.log(response);
          this.subscription = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>
